import services from "./index";
import qs from "querystring";

export default {
    postForm(mode, request) {
        return services.http.post(`/v1.0/platform/form/${mode}`, request);
    },
}